import { useState } from 'react';
import { SideBar, Tooltip } from '@equinor/eds-core-react';
import { arrow_back as arrowBack } from '@equinor/eds-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSidebarConfig } from './useSidebarConfig';
import { StyledBackButton, StyledSidebar } from './Sidebar.styled';
import type { SidebarLink } from './types';

export const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { links, backAction } = useSidebarConfig();
  const [open, setOpen] = useState(true);

  const isActive = (path: string) => {
    const [pathname, search] = path.split('?');
    if (search) {
      return location.pathname === pathname && location.search === `?${search}`;
    }
    return location.pathname === pathname && !location.search;
  };

  const isParentActive = (link: SidebarLink) =>
    location.pathname === link.path ||
    (link.children?.some((child) => isActive(child.path)) ?? false);

  return (
    <StyledSidebar open={open} onToggle={(state) => setOpen(state)}>
      <SideBar.Content>
        {backAction &&
          (backAction.disabledTooltip ? (
            <Tooltip title={backAction.disabledTooltip}>
              <StyledBackButton label={backAction.label} icon={arrowBack} />
            </Tooltip>
          ) : (
            <StyledBackButton
              label={backAction.label}
              icon={arrowBack}
              onClick={backAction.onBack}
            />
          ))}

        {links.map((link) =>
          link.children ? (
            <SideBar.Accordion
              key={link.title}
              label={link.title}
              icon={link.icon}
              active={isParentActive(link)}
              isExpanded={link.nonCollapsible || isParentActive(link)}
            >
              {link.children.map((child) => (
                <SideBar.AccordionItem
                  key={child.path}
                  label={child.title}
                  active={isActive(child.path)}
                  onClick={() => navigate(child.path)}
                />
              ))}
            </SideBar.Accordion>
          ) : (
            <SideBar.Link
              key={link.title}
              label={link.title}
              icon={link.icon}
              active={isActive(link.path)}
              onClick={() => navigate(link.path)}
            />
          ),
        )}
        <SideBar.Toggle />
      </SideBar.Content>
    </StyledSidebar>
  );
};
